import React, { useContext } from "react";
import { motion } from "framer-motion";
// import { FaMoneyBillTrendUp } from "react-icons/fa6";
import DataContext from "../Context/DAtaContext";
import UsersContext from "../Context/UsersContext";

function SummaryTable({ RegFarmers, userdetails }) {
  const { Payment, Zones } = useContext(DataContext);
  const { Villages } = useContext(DataContext);
  const { users, user } = useContext(UsersContext);

  // handle Payment filtration
  // Filter payments for each farmer
  const Payfilter = RegFarmers?.map((user) =>
    Payment?.filter((dt) => dt?.farmer_id === user?.uuid),
  );

  // Flatten the array of arrays into a single array of payment objects
  const cprices = Payfilter?.flat();

  // Calculate the total sum of all payments
  const TotalPrice = cprices?.reduce((accumulator, currentValue) => {
    return accumulator + (currentValue?.amount || 0); // Sum the 'amount' field, default to 0 if undefined
  }, 0);

  // objective target logic
  const userProfile = users?.find((dt) => dt?.id === user?.id);
  const village = Villages?.find((dt) => dt?.id === userProfile?.village_id);
  const ZoneTarget = Zones?.find((dt) => dt?.id === village?.zone_id);

  // Helper function to calculate percentage safely
  const calculatePercentage = (achieved, target, fallbackTarget = 0) => {
    const actualTarget = target || fallbackTarget;
    if (!actualTarget || actualTarget <= 0) return 0;
    return Math.min((achieved / actualTarget) * 100, 100); // Cap at 100%
  };

  // Helper function to get color class based on percentage
  const getPercentageColor = (percentage) => {
    if (percentage < 33) return "text-red-600";
    if (percentage < 66) return "text-yellow-600";
    return "text-green-600";
  };

  // Calculate values for enrollment row
  const enrollmentTarget = ZoneTarget?.target || 80;
  const enrollmentAchieved = RegFarmers?.length || 0;
  const enrollmentRemaining = Math.max(
    enrollmentTarget - enrollmentAchieved,
    0,
  );
  const enrollmentPercentage = calculatePercentage(
    enrollmentAchieved,
    enrollmentTarget,
  );

  // Calculate values for sales row
  const salesTarget = ZoneTarget?.sales || 6080000;
  const salesAchieved = TotalPrice || 0;
  const salesRemaining = Math.max(salesTarget - salesAchieved, 0);
  const salesPercentage = calculatePercentage(salesAchieved, salesTarget);

  return (
    <div>
      <div className="flex flex-row items-center mb-5 text-xs md:text-sm gap-x-3">
        {/* <FaMoneyBillTrendUp className="text-lg md:text-xl" /> */}
        <div>
          <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
            Data Summary for {userdetails?.[0]?.name || "User"}
          </h1>
        </div>
      </div>
      <div className="overflow-x-auto ">
        {/* Enables horizontal scrolling on small screens */}
        <motion.table
          className="w-full"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <thead className="">
            <tr className="bg-green-600 border-b dark:border-gray-600 md:text-sm">
              <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                Particulars
              </th>
              <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                Target
              </th>
              <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                Achieved
              </th>
              <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                Remain
              </th>
              <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                %
              </th>
            </tr>
          </thead>
          <tbody className="">
            <motion.tr className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 ">
              <td className="p-2 text-xs text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                Enrollment
              </td>
              <td className="p-2 text-xs text-center text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                {enrollmentTarget.toLocaleString()}
              </td>
              <td className="p-2 text-xs text-center text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                {enrollmentAchieved.toLocaleString()}
              </td>
              <td className="p-2 text-xs text-center text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                {enrollmentRemaining.toLocaleString()}
              </td>
              <td
                className={`p-2 text-xs md:py-3 text-center md:text-sm ${getPercentageColor(
                  enrollmentPercentage,
                )}`}
              >
                {enrollmentPercentage.toFixed(2)}%
              </td>
            </motion.tr>
            <motion.tr className="bg-white border-b hover:bg-green-100 dark:bg-slate-900 dark:border-gray-700">
              <td className="p-2 text-xs text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                Sales
              </td>
              <td className="p-2 text-xs text-center text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                {salesTarget.toLocaleString()}
              </td>
              <td className="p-2 text-xs text-center text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                {salesAchieved.toLocaleString()}
              </td>
              <td className="p-2 text-xs text-center text-gray-900 md:py-3 dark:text-gray-300 md:text-sm">
                {salesRemaining.toLocaleString()}
              </td>
              <td
                className={`p-2 text-xs md:py-3 text-center md:text-sm ${getPercentageColor(
                  salesPercentage,
                )}`}
              >
                {salesPercentage.toFixed(2)}%
              </td>
            </motion.tr>
          </tbody>
        </motion.table>
      </div>
    </div>
  );
}

export default SummaryTable;
